export default function getReferenceByKey(searchoptions, param) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    makeCode,
    modelCode,
    category = ''
  } = options;

  // get the makeCode list if it is supplied
  const getMakeCodes = () => searchoptions.makeCode.find(make => [].concat(makeCode).includes(make.code)) || {};
  let data;
  try {
    switch (param) {
      case 'makeCode':
        {
          let makes = searchoptions[param];

          // if a filter category is specified(e.g.: 'COMMERCIAL') return only the makes related to that category
          if (category) {
            makes = makes.filter(make => {
              var _make$categories;
              return make === null || make === void 0 || (_make$categories = make.categories) === null || _make$categories === void 0 ? void 0 : _make$categories.includes(category);
            });
          }
          data = makes;
          break;
        }
      case 'modelCode':
        {
          // getting modelCode reference requires a makeCode to be passed
          if (makeCode) {
            // return the model list of a makeCode if it is supplied
            const {
              models: allModels = []
            } = getMakeCodes();
            let models = allModels;

            // if a filter category is specified(e.g.: 'COMMERCIAL') return only the models related to that category
            if (category) {
              models = allModels.filter(model => model.categories && model.categories.includes(category));
            }
            data = models;
          }
          break;
        }
      case 'seriesCode':
        {
          // getting seriesCode reference requires a makeCode to be passed
          if (makeCode) {
            const {
              models = []
            } = getMakeCodes();
            // generate a deduped list of all specified series codes
            const seriesCodes = Object.values(models.reduce((acc, model) => {
              if (model.classSeries && !acc[model.classSeries.code]) {
                // if a filter category is specified(e.g.: 'COMMERCIAL') return only the series related to that category
                if (category && model.categories && model.categories.includes(category)) {
                  acc[model.classSeries.code] = model.classSeries;
                } else if (!category) {
                  acc[model.classSeries.code] = model.classSeries;
                }
              }
              return acc;
            }, {}));
            data = seriesCodes;
          }
          break;
        }
      case 'trimCode':
        {
          // getting trimCode reference requires a makeCode and a modelCode to be passed
          if (makeCode && modelCode) {
            const {
              models = []
            } = getMakeCodes();
            // return the trim list of a modelCode of a makeCode if it is supplied
            const {
              trims = []
            } = models.find(model => [].concat(modelCode).includes(model.code)) || {};
            data = trims;
          }
          break;
        }
      case 'vehicleStyleCode':
        {
          if (category) {
            data = searchoptions[param].filter(style => style.categories && style.categories.includes(category));
            if (category === 'COMMERCIAL') {
              data.forEach(styleObject => {
                if ((styleObject === null || styleObject === void 0 ? void 0 : styleObject.code) === 'VANMV') {
                  styleObject.altName = {
                    commercial: 'Van'
                  };
                }
              });
            }
            break;
          } else {
            data = searchoptions[param];
          }
          break;
        }
      case 'extColorSimple':
        {
          data = searchoptions.extColorGroups;
          break;
        }
      default:
        data = searchoptions[param];
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err, param, options);
  }
  return data;
}